import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { OrderedMap } from "immutable";
import WidgetCard from "views/components/widgets/WidgetCard";
import SecurityEventsHistogram from "security-app/components/SecurityEvents/Alerts/SecurityEventsHistogram";
import { nonInfoPriorities } from "components/events/Constants";
import useWelcomeTimeRangeSeconds from "components/welcome/hooks/useMetricsTimeRange";
import timerangeToString from "views/logic/queries/TimeRangeToString";
import useUserDateTime from "hooks/useUserDateTime";
export const WIDGET_HEIGHT = "259px";
const NOOP_SET_FILTERS = () => {
};
const StyledWidgetCard = styled(WidgetCard)`
  height: 100%;
`;
const WelcomeEventsHistogram = () => {
  const { t } = useTranslation("enterprise_security_app");
  const rangeSeconds = useWelcomeTimeRangeSeconds();
  const { formatTime } = useUserDateTime();
  const [effectiveTimeRange, setEffectiveTimeRange] = useState();
  const filters = OrderedMap({
    timestamp: [`relative@${rangeSeconds}`],
    priority: nonInfoPriorities
  });
  const searchParams = {
    page: 1,
    pageSize: 1,
    query: "",
    sort: { attributeId: "timestamp", direction: "desc" },
    filters
  };
  const timeRangeInfo = timerangeToString({ type: "relative", range: rangeSeconds });
  const timeRangeTooltip = effectiveTimeRange ? timerangeToString(effectiveTimeRange, (dateTime) => formatTime(dateTime, "internal")) : void 0;
  return /* @__PURE__ */ React.createElement(StyledWidgetCard, { headline: t("welcome_metrics.events_and_alerts"), timeRangeInfo, timeRangeTooltip }, /* @__PURE__ */ React.createElement(
    SecurityEventsHistogram,
    {
      searchParams,
      setFilters: NOOP_SET_FILTERS,
      height: WIDGET_HEIGHT,
      readOnly: true,
      onEffectiveTimeRangeChange: setEffectiveTimeRange
    }
  ));
};
export default WelcomeEventsHistogram;
